import { render, staticRenderFns } from "./msGroupTr.vue?vue&type=template&id=2aa80729&scoped=true"
import script from "./msGroupTr.vue?vue&type=script&lang=js"
export * from "./msGroupTr.vue?vue&type=script&lang=js"
import style0 from "./msGroupTr.vue?vue&type=style&index=0&id=2aa80729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa80729",
  null
  
)

export default component.exports